export const API_URL = process.env.REACT_APP_API_URL;
export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY;
export const APP_VERSION = process.env.REACT_APP_VERSION || 'build-xyz';
export const RETAILER_NAME = process.env.REACT_APP_RETAILER_NAME;